// extracted by mini-css-extract-plugin
export default {"container":"style_container__IgEFN","loader":"style_loader__XX+dw"};